import axios from "./axios";
import { ADMIN_API_ROOT } from "./api-root";

export const MemberServer = {
    User: {
        /**
         * 用户列表
         */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/member/list`,
                { params }
            );
        },
        /**
         * 创建用户
         */
        create: (params: any) => {
            return axios.post(`${ADMIN_API_ROOT}/member/add`, params);
        },
        /**
         * 修改用户信息
         */
        modify: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/member/update`,
                params
            );
        },
        /**
        * 修改用户状态
        */
        enabled: async (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/member/update`,
                { ...params, Status: params.Status ? 1 : 2 }
            );
        },
        /**
         * 删除用户
         */
        delete: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/member/delete`,
                params
            );
        },
        /**
         * 上下分
         */
        updateAmount: (params: any) => {
            return axios.post(`${ADMIN_API_ROOT}/member/update-amount`, params);
        },
        /**
         * 重置验证码
         */
        resetCode: (params?: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/member/reset-google-verify`, params);
        },
    },
    Manager: {
        /**
       * 用户列表
       */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/manager/list`,
                { params }
            );
        },
        /**
         * 创建用户
         */
        create: (params: any) => {
            return axios.post(`${ADMIN_API_ROOT}/manager/add`, params);
        },
        /**
         * 修改用户信息
         */
        modify: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/manager/update-info`,
                params
            );
        },
        /**
         * 管理员更新密码
         */
        modifyPwd: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/manager/update-password`,
                params
            );
        },
        /**
        * 修改用户状态
        */
        enabled: async (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/manager/update-info`,
                { ...params, Status: params.Status ? 1 : 2 }
            );
        },
        /**
         * 删除用户
         */
        delete: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/manager/delete`,
                params
            );
        },
        /**
         * 当前管理员路由列表
         */
        getManagerRoles: (params: any) => {
            return axios.get(`${ADMIN_API_ROOT}/index/route-list`, { params });
        }
    },
    Role: {
        /**
       * 用户列表
       */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/role/list`,
                { params }
            );
        },
        /**
         * 用户列表(分页)
         */
        pageList: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/role/page-list`,
                { params }
            );
        },
        /**
         * 创建用户
         */
        create: (params: any) => {
            return axios.post(`${ADMIN_API_ROOT}/role/add`, params);
        },
        /**
         * 修改用户信息
         */
        modify: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/role/update-info`,
                params
            );
        },
        /**
        * 修改用户状态
        */
        enabled: async (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/role/update-info`,
                { ...params, Status: params.Status ? 1 : 2 }
            );
        },
        /**
         * 删除用户
         */
        delete: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/role/delete`,
                params
            );
        },
        /**
         * 角色路由
         */
        routes: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/role/routes`,
                { params }
            );
        },
        /**
         * 角色分配路由
         */
        dispenseRoutes: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/role/dispense-routes`,
                params
            );
        },
    },
    Privilege: {
        /**
        * 路由列表(tree数状结构，角色选择权限时用到)
        */
        tree: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/route/tree-list`,
                { params }
            );
        },
        /**
         * 路由列表
         */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/route/list`,
                { params }
            );
        },

    }
}